import { mobileRegex, subdomainMappingRegex } from './regex';

export function detectMobileDevice(): boolean {
  return mobileRegex.test(navigator.userAgent) || navigator.maxTouchPoints > 0;
}

export function toEnum<T extends Record<string, string>>(enumObj: T, value: string): T[keyof T] | undefined {
  return Object.values(enumObj).includes(value as T[keyof T]) ? (value as T[keyof T]) : undefined;
}

export function getClientFromUrl(
  url: string = window.location.href
): { client: string; environment: string } | undefined {
  const mapping: { regex: RegExp; client: string; environment: string }[] = [
    { regex: subdomainMappingRegex.ao_prod, client: 'ao', environment: 'prod' },
    { regex: subdomainMappingRegex.ao_uat, client: 'ao', environment: 'uat' },
    { regex: subdomainMappingRegex.ao_dev, client: 'ao', environment: 'dev' },
    { regex: subdomainMappingRegex.hoover_prod, client: 'hoover', environment: 'prod' },
    { regex: subdomainMappingRegex.hoover_uat, client: 'hoover', environment: 'uat' },
    { regex: subdomainMappingRegex.hoover_dev, client: 'hoover', environment: 'dev' },
    { regex: subdomainMappingRegex.sky_prod, client: 'sky', environment: 'prod' },
    { regex: subdomainMappingRegex.sky_uat, client: 'sky', environment: 'uat' },
    { regex: subdomainMappingRegex.sky_dev, client: 'sky', environment: 'dev' },
    { regex: subdomainMappingRegex.dg_prod, client: 'dg', environment: 'prod' },
    { regex: subdomainMappingRegex.dg_uat, client: 'dg', environment: 'uat' },
    { regex: subdomainMappingRegex.dg_dev, client: 'dg', environment: 'dev' },
    { regex: subdomainMappingRegex.ao_cypress, client: 'ao', environment: 'dev' },
    { regex: subdomainMappingRegex.dg_cypress, client: 'dg', environment: 'dev' },
  ];

  const match = mapping.find((m) => m.regex.test(url));

  if (!match) return undefined;
  return { client: match.client, environment: match.environment };
}
